const phone = window.matchMedia('(max-width: 1024px)');
const feed = document.getElementById('insta-feed');

if (feed) {
  const registered = new WeakSet();
  const prepared = new WeakSet();
  const visible = new Set();
  const pending = new WeakSet();
  let automaticVideo;

  function playVisibleVideo() {
    if (!phone.matches || document.hidden) return;
    if (automaticVideo && visible.has(automaticVideo) && !automaticVideo.paused) return;
    const video = visible.values().next().value;
    if (!video || pending.has(video)) return;
    if (automaticVideo && automaticVideo !== video) automaticVideo.pause();
    automaticVideo = video;
    video.muted = true;
    video.playsInline = true;
    pending.add(video);
    video.play().catch(() => {}).finally(() => pending.delete(video));
  }

  const nearby = new IntersectionObserver((entries) => {
    for (const { target: video, isIntersecting } of entries) {
      if (!isIntersecting) continue;
      if (!video.poster && video.dataset.poster) video.poster = video.dataset.poster;
      if (!prepared.has(video)) {
        prepared.add(video);
        if (video.paused && video.readyState === 0) {
          video.preload = 'metadata';
          video.load();
        }
      }
      nearby.unobserve(video);
    }
  }, { rootMargin: '600px 0px' });

  const onScreen = new IntersectionObserver((entries) => {
    for (const { target: video, isIntersecting } of entries) {
      if (isIntersecting) {
        visible.add(video);
      } else {
        visible.delete(video);
        if (video === automaticVideo) {
          video.pause();
          automaticVideo = undefined;
        }
      }
    }
    playVisibleVideo();
  }, { threshold: 0.15 });

  function registerVideo(video) {
    if (registered.has(video)) return;
    registered.add(video);
    nearby.observe(video);
    onScreen.observe(video);
    video.addEventListener('canplay', playVisibleVideo);
    video.addEventListener('ended', playVisibleVideo);
  }

  function scan(element) {
    if (element.matches('.auto-loop-videos')) registerVideo(element);
    element.querySelectorAll('.auto-loop-videos').forEach(registerVideo);
  }

  function unregisterVideo(video) {
    visible.delete(video);
    registered.delete(video);
    nearby.unobserve(video);
    onScreen.unobserve(video);
    video.removeEventListener('canplay', playVisibleVideo);
    video.removeEventListener('ended', playVisibleVideo);
    if (video === automaticVideo) {
      video.pause();
      automaticVideo = undefined;
    }
  }

  scan(feed);
  const updates = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) scan(node);
      }
      for (const node of record.removedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('.auto-loop-videos')) unregisterVideo(node);
        node.querySelectorAll('.auto-loop-videos').forEach(unregisterVideo);
      }
    }
  });
  updates.observe(feed, { childList: true, subtree: true });

  feed.addEventListener('touchend', playVisibleVideo, { passive: true });
  feed.addEventListener('click', playVisibleVideo);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) automaticVideo?.pause();
    else playVisibleVideo();
  });
  phone.addEventListener('change', playVisibleVideo);
}
